<script setup lang="ts">
import DroneSpinnerURL from 'Assets/nea_spinner_light.svg?url'
</script>

<template>
  <img class="h-60 w-60" :src="DroneSpinnerURL" alt="Drone Styled Loading Indicator" />
</template>
